export default {
  serverURI: '',
  version: '',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js